var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('section',{attrs:{"id":"settings-subscription"}},[_c('h2',{staticClass:"pb-2"},[_vm._v(_vm._s(_vm.$t('subscription')))]),_c('div',[_vm._v("По вопросам оплат свяжитесь с администрацией школы")])])}
var staticRenderFns = []

export { render, staticRenderFns }